import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { addFacility } from 'slices/facilitiesSlice';
import { facilitySelector } from 'slices/facilitiesSlice';
import ErrorMessage from 'components/common/ErrorMessage';
import { setError } from 'slices/facilitiesSlice';
import toast from 'react-hot-toast';
import { updateFacility } from 'slices/facilitiesSlice';
import { fetchFacilities } from 'slices/facilitiesSlice';
import { Button, Spinner } from 'reactstrap';
import Api from "services/api"
import { CustomSwitch } from 'components/common/Switch';
import { fetchCitys } from 'slices/citySlice';
import { fetchStates } from 'slices/stateSlice';
import { stateSelector } from 'slices/stateSlice';
import { citySelector } from 'slices/citySlice';
import { Select } from 'components/common/Select';
import { facilitiesSelector } from 'slices/facilitiesSlice';
import PhoneInput from 'components/common/PhoneInput';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';

const apiService = new Api();
const AddFacilityForm = ({ item, handleClose, callback, show, statusPerm }) => {
  const dispatch = useDispatch()
  const { register, handleSubmit, watch, formState: { errors }, control, setValue, } = useForm();
  const { error, loader } = useSelector(facilitiesSelector);
  const { state: states } = useSelector(stateSelector);
  const { city: cities } = useSelector(citySelector);
  const [allStates, setAllStates] = React.useState([]);
  const [filterStates, setfilterStates] = useState({
    label: "",
    value: ""
  })


  useEffect(() => {
    // dispatch(fetchCitys(1, { pageLength: 1000, sortBy: "id", sortDirection: "asc" }));
    // dispatch(fetchStates(1, { pageLength: 1000, sortBy: "id", sortDirection: "asc" }))
    setValue('abbreviation', item?.abbreviation || '')
    setValue('contact', item?.contact || '')
    setValue('address', item?.address || '');
    setValue('location', item?.location || '');

    setValue('city_name', item?.city_name || '');
    setValue('zip_code', item?.zip_code || '');
    setValue('status', (typeof (item?.status) == "number") ? item?.status : 1)
    dispatch(setError({}))
  }, [item])

  const ResetField = () => {
    setValue('abbreviation', '');
    setValue("contact", '');
    setValue('address', '');
    setValue('location', '');
    setValue('zip_code', '');
    setValue('status', 1)
    setValue("city_name", '')
    setValue("state_id", '')
  }

  useEffect(() => {
    !show && ResetField();
    return () => ResetField()
  }, [show])

  useEffect(() => {
    if (states?.length > 0) {
      if (item?.state_id)
        setValue("state_id", item?.state_id);
      dispatch(fetchStates(1, { search: item?.state?.name }, true, true))
      // else
      //   setValue("state_id", states ? states[0]?.id : null)
    }

    // if (item?.city_id)
    //   setValue("city_id", item?.city_id)

  }, [item, states, allStates]);





  const submitCallback = (status, message) => {
    if (status) {
      callback()
      toast.success(message, {
        className: "successToast",
      })
      dispatch(fetchFacilities())
      handleClose()
      ResetField()
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const onSubmit = (data) => {
    // Handle form submission
    dispatch(setError({}))
    if (item?.id) {
      dispatch(updateFacility(data, item?.id, submitCallback));
    } else
      dispatch(addFacility(data, submitCallback));

  }

  // #region States dropdown

  useEffect(() => {
    if (item?.state?.name && item?.state?.id) {
      setfilterStates({
        label: item?.state?.name || "",
        value: item?.state?.id || ""
      })
    } else {
      setfilterStates(null)
    }
  }, [item?.state])


  const filteredStatesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchStates(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
    setAllStates(result?.data)
    return {
      options: result.data.map(val => ({
        value: val.id,
        label: val.name,
      })),

      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion

  // #region City dropdown
  const [allCities, setAllCities] = useState([])
  const [selectedCity, setSelectedCity] = useState({
    label: "",
    value: ""
  })
  const filteredCities = React.useMemo(() =>
    allCities?.map(item => {
      const object = {
        label: item?.name,
        value: item?.id,
      }
      return object
    }), [allCities]);


  const filteredStates = React.useMemo(() => {

    setAllCities(item?.state?.name != null ? states?.find(state => state?.name == item?.state?.name)?.cities : [])
    return states?.map(item => {
      const object = {
        label: item?.name,
        value: item?.id,
      }
      return object
    })
  }, [states, item?.state?.name]);

  useEffect(() => {
    setSelectedCity(filteredCities)
  }, [filteredCities])

  useEffect(() => {
    if (item?.city?.name && item?.city?.id) {
      setSelectedCity({
        label: item?.city?.name || "",
        value: item?.city?.id || ""
      })
    } else {
      setSelectedCity(null)
    }
  }, [item?.city])

  //#endregion


  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row-primary">
          <h2>Abbreviation *</h2>

          <Controller
            name="abbreviation"
            control={control}
            render={({ field }) => <input className="input-in type_inp" type="text" name='abbreviation' placeholder='Abbreviation' required {...field} />}

          />

        </div>


        <div className="row-primary">
          <h2>Location *</h2>
          <input className="input-in type_inp" type="text" {...register("location", { required: true })} name='location' required placeholder="Location" />
        </div>
        <div className="row-primary">
          <h2>Address *</h2>
          <input className="input-in type_inp" type="text" {...register("address", { required: true })} name='address' required placeholder="Address" />
        </div>


        <div className="row-primary">
          <h2>Select State *</h2>
          <Controller
            name="state_id"
            control={control}
            rules={{
              required: "Please select a state"
            }}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <AsyncPaginate
                  menuPlacement='auto'
                  styles={{
                    ...selectCustomStyles,
                  }}
                  value={filterStates}
                  defaultOptions={item?.state?.id ? filteredStates : []}
                  loadOptions={filteredStatesLoadOptions}
                  isClearable
                  escapeClearsValue
                  onChange={(obj) => {
                    setfilterStates(obj)
                    setAllCities(obj != null ? allStates?.find(states => states?.name == obj?.label)?.cities : [])
                    field.onChange(obj?.value);
                  }}
                  additional={{
                    page: item?.state?.id ? 2 : 1,
                  }}
                />

                {errors?.state_id?.message &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.state_id?.message} />
                  </div>
                }

              </div>
            }
          />
        </div>

        {/* <div className="row-primary">
          <h2>Select City *</h2>
          <Controller
            name="city_id"
            control={control}
            rules={{
              required: "Please select a City"
            }}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <Select
                  name="city_id"
                  options={filteredCities || []}
                  {...field}
                  value={filterStates ?? item?.city ? (filteredCities?.find((opt) => field.value === opt.value) || []) : null}
                />
                {errors?.city_id?.message &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.city_id?.message} />
                  </div>
                }
              </div>
            }
          />
        </div> */}


        <div className="row-primary">
          <h2>City Name *</h2>
          <Controller
            name="city_name"
            control={control}
            render={({ field }) => (
              <div className="w-100">
                <input
                  className="input-in type_inp"
                  type="text"
                  name="city_name"
                  placeholder="Enter City Name"
                  {...field}
                />
                {errors?.city_name?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.city_name?.message} />
                  </div>
                )}
              </div>
            )}
          />
        </div>        

        <div className="row-primary">
          <h2>Zip Code *</h2>
          <input className="input-in type_inp" type="text" {...register("zip_code", { required: true })} name='zip_code' required placeholder="Zip Code" />
        </div>

        <div className="row-primary">
          <h2>Cell Phone *</h2>
          <Controller
            name="contact"
            control={control}
            rules={{
              required: true
            }}
            render={({ field }) => <PhoneInput className={`input-in type_inp ${error?.errors?.contact ? "border-red" : ""} `}
              type="tel" name='contact' placeholder='Phone number' required {...field} />}
          />
        </div>

        {statusPerm &&
          <div className="row-primary" style={{ alignItems: "center" }}>
            <h2>Status</h2>
            <Controller name="status" control={control} required
              rules={{
                required: true
              }}
              render={({ field }) => (
                <CustomSwitch labelText={field.value == 1 ? "Active" : "Inactive"} checked={field.value} handleChange={(checked) => field.onChange(checked ? 1 : 0)} />
              )}
            />
          </div>
        }


        {error?.errors?.contact?.map((error) => (
          <div style={{ marginBottom: 10 }}>
            <ErrorMessage text={error} />
          </div>
        ))}

        {error?.errors?.city_id?.map((error) => (
          <div style={{ marginBottom: 10 }}>
            <ErrorMessage text={error} />
          </div>
        ))}


        {error?.errors?.state_id?.map((error) => (
          <div style={{ marginBottom: 10 }}>
            <ErrorMessage text={error} />
          </div>
        ))}

        {error?.errors?.zip_code?.map((error) => (
          <div style={{ marginBottom: 10 }}>
            <ErrorMessage text={error} />
          </div>
        ))}

        <div className="Form-footer">
          <button type="button" className="Cancle_button" data-bs-dismiss="modal">Cancel</button>
          <button type="submit" className="main_button">

            {loader ?
              <>
                <Spinner size="sm">
                  Loading...
                </Spinner>

                <span>
                  {' '}Loading
                </span>
              </>
              :
              <span>
                {item?.id ? "Update" : "Create"}
              </span>
            }
          </button>
        </div>
      </form>

    </div>
  )
}

const AddFacility = ({ item, onClose, callback, show, statusPerm }) => {
  return (
    <div className={`modal fade`} id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content full_modal">
          <div className="modal-header header_modal align-items-center">
            <div></div>
            <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Facility</h5>
            <button onClick={onClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body modal_form_body">
            <AddFacilityForm item={item} handleClose={onClose} show={show} callback={callback} statusPerm={statusPerm} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddFacility
